export const firebaseConfig = {
    apiKey: "AIzaSyAfoIndVTvGzJajCXjSlCLwc-VVspMgawM",
    authDomain: "kunjisoft-app.firebaseapp.com",
    databaseURL: "https://kunjisoft-app-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "kunjisoft-app",
    storageBucket: "kunjisoft-app.appspot.com",
    messagingSenderId: "796322410374",
    appId: "1:796322410374:web:50e80fee9fd18cb8af4607",
    measurementId: "G-9T76CCLR6E"
};